import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
// import 'es6-set/implement'
// import 'es6-map/implement'
import 'string.prototype.startswith'


import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from './application/AppState';
import App from './App';
import { load as loadSettings } from "./application/settings";
import './index.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const start = async () => {
  await loadSettings();

  root.render(
    <BrowserRouter basename={baseUrl}>
      <AppStateProvider>
        <App />
      </AppStateProvider>
    </BrowserRouter>
  );
};

start();
